import { render } from "./EditExternalP2PCurrencies.vue?vue&type=template&id=14bd794f"
import script from "./EditExternalP2PCurrencies.vue?vue&type=script&lang=js"
export * from "./EditExternalP2PCurrencies.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__